import { t } from 'react-i18nify'
import './ChangePassword.scss'

export function ChangePassword() {
    return (
        <div className='limit-width'>
          <h2>{t('Change password')}</h2>
          <form className='form'>
          <input type='password' placeholder={t('Current password')}></input>
          <input type='password' placeholder={t('New password')}></input>
          <input type='password' placeholder={t('Repeat new password')}></input>
          </form>
        </div>
    )
}
